// getLiveStreamIds.js
'use strict';
import {
  LIVESTREAM_FEED,
  LIVESTREAM_FEED_SORTINGS,
} from '../RemoteConfigKeys.js';

import createCachedSelector from '../resource/createCachedSelector.js';
import { sanitizeFeedQuery } from '../resource/feedUtils.js';

import { getReturnType } from '../action/fetchFeeds.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getListData from '../selector/getListData.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';

const defaultList = [];
/**
 * Select live stream ids by feed name and current active stream id.
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} currentActiveStreamId - current active stream id.
 * @return {array} The selected live stream ids.
 */
const getLiveStreamIds = createCachedSelector(
  state => {
    const feedName = getRemoteConfigData(state, LIVESTREAM_FEED);
    const { feedNameWithQuery } = getSelectedQueryOptionObject(
      state,
      feedName,
      getSelectedFeedQueryOptions(state, LIVESTREAM_FEED, undefined),
      getRemoteConfigData(state, LIVESTREAM_FEED_SORTINGS)?.[0]
    );
    const sanitizedFeedNameWithQuery = sanitizeFeedQuery({
      feedName: feedNameWithQuery,
    });
    const selectPath = [
      'home',
      getReturnType({ feedName: sanitizedFeedNameWithQuery }),
      sanitizedFeedNameWithQuery,
    ];
    const itemIds = getListData(state, selectPath, 'itemIds');
    return itemIds;
  },
  (state, currentActiveStreamId) => currentActiveStreamId,
  (streamIds = defaultList, currentActiveStreamId) => {
    if (currentActiveStreamId) {
      const isActiveStreamIdInList = streamIds.includes(currentActiveStreamId);

      if (isActiveStreamIdInList) {
        return streamIds;
      }

      return [...streamIds, currentActiveStreamId];
    }

    return streamIds;
  }
)((state, currentActiveStreamId) => `${currentActiveStreamId}`);

export default getLiveStreamIds;
